/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMoeGoogleSlidesViewProps } from './moe-google-slides';

export default (props: IMoeGoogleSlidesViewProps) => {
    const { config } = props;
    return (
        <div tabIndex={0} className='moe-google-slide'>
            <h2 className='moe-google-slide__ttl'>{config.googleSlideTitle}</h2>
            <div className='moe-google-slide__iframe-cont'>
                <iframe
                    className='moe-google-slide__iframe'
                    src={config.googleSlideUrl}
                    frameBorder='0'
                    allow='autoplay; fullscreen; picture-in-picture'
                    title='36356c21-547d-48f8-83b1-025c3b4d_650.mp4'
                ></iframe>
            </div>
        </div>
    );
};
